export const CountryCodeList = [
  { id: '+47', name: '+47 Norge' },
  { id: '+46', name: '+46 Sverige' },
  { id: '+45', name: '+45 Danmark' }
];
